export default {"src":"/_next/static/media/il.bbd51042.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};